let featuresSlider = "";

function initFeaturesSlider() {
    featuresSlider = $('.js-features-slider').slick({
        dots: true,
        variableWidth: false,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
    });
}

$(document).ready(function() {
    if ($('.js-features-slider').length > 0 
        && $(window).width() < 1024) {
        initFeaturesSlider();
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/main/features.js